import { configureStore } from "@reduxjs/toolkit";
import homeReducer from "../pages/Home/homeSlice";
import loginReducer from "../pages/Login/loginSlice";
import answerReducer from "../pages/Answer/answerSlice";
import donationOrderReducer from "../pages/DonationOrder/donationOrderSlice";
import orderDetailsReducer from "../pages/OrderDetails/orderDetailsSlice";
import locationSurveyReducer from "../pages/LocationSurvey/locationSurveySlice";
import registerReducer from "../pages/Register/registerSlice";
import corporateArtPortalReducer from "../pages/CorporateArtPortal/CorporateArtPortalSlice";
import artWorkSelectionReducer from "../pages/ArtWorkSelection/artWorkSelectionSlice";

export default configureStore({
    reducer: {
        home: homeReducer,
        login: loginReducer,
        answer: answerReducer,
        corporateArtPortal: corporateArtPortalReducer,
        donationOrder: donationOrderReducer,
        orderDetails: orderDetailsReducer,
        locationSurvey: locationSurveyReducer,
        register: registerReducer,
        artWorkSelection: artWorkSelectionReducer,
    },
});
